;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockSubcategoryProductSlider from './BlockSubcategoryProductSlider';

const query = /* GraphQL */ `
    ${assetFragment}
    ${ctaFragment}
    ${linkFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockSubcategoryProductSlider(preview: $preview, id: $id) {
            __typename
            sys {
                id
            }
            description
            backgroundColor
            cardHoverColor
            subcategory
            isNew
            cta {
                ... on Cta {
                    ...CTA
                }
            }
            productsCollection(limit: 50) {
                items {
                    __typename
                    sys {
                        id
                    }
                    displayName
                    eyebrow
                    slug
                    color
                    textColor
                    icon
                    image {
                        ...Asset
                    }
                    category {
                        slug
                        title
                    }
                }
            }
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockSubcategoryProductSlider },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });

    return blockSubcategoryProductSlider;
}

const BlockSubcategoryProductSliderServer = async ({ id }) => {
    const block = await fetchBlock(id);

    return (
        <BlockSubcategoryProductSlider
            {...block}
            products={(block?.productsCollection?.items || []).filter(Boolean)}
        />
    );
};

export default BlockSubcategoryProductSliderServer;
